import { GraphAnchor, GraphKind } from '../../services/owner-graph.service';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Les écrans qui SONT une fiche, et la fiche qu'ils montrent. Les sous-pages
 * d'une fiche comptent pour elle (`details-owner/:id/account-management/…`).
 * `indexing-candidate-detail/:id` porte l'id du bail ; `indexation-case/:id`
 * celui d'un dossier, et n'y figure donc pas.
 */
const RECORD_ROUTES: { prefix: string[]; kind: GraphKind }[] = [
  { prefix: ['leases', 'details-lease'], kind: 'lease' },
  { prefix: ['leases', 'indexing-candidate-detail'], kind: 'lease' },
  { prefix: ['owners', 'details-owner'], kind: 'owner' },
  { prefix: ['tenants', 'details-tenant'], kind: 'tenant' },
  { prefix: ['properties', 'details-property'], kind: 'property' },
];

/**
 * La fiche ouverte à `url` (celle du routeur, requête et fragment compris), ou
 * `null` quand l'écran n'en est pas une. Lu sur l'URL plutôt que sur l'arbre
 * des routes : la palette s'ouvre depuis la coque, qui ne voit pas les
 * paramètres des routes filles.
 */
export function currentRecord(url: string): GraphAnchor | null {
  const path = url.split(/[?#]/)[0];
  const segments = path.split('/').filter(Boolean).map(decodeURIComponent);

  for (const route of RECORD_ROUTES) {
    const matches = route.prefix.every((seg, i) => segments[i] === seg);
    const id = segments[route.prefix.length];
    if (matches && id && UUID.test(id)) return { kind: route.kind, id };
  }
  return null;
}

/** La route de la fiche — la même que celle des listes. */
export function recordLink(kind: GraphKind, id: string): string[] {
  switch (kind) {
    case 'lease': return ['/leases/details-lease', id];
    case 'owner': return ['/owners/details-owner', id];
    case 'tenant': return ['/tenants/details-tenant', id];
    case 'property': return ['/properties/details-property', id];
  }
}
